export default "__VITE_ASSET__BdJKrVSy__"